class LogoutController {
    /*@ngInject*/
    constructor(MobileAppService, CommonService) {
        this.MobileAppService = MobileAppService;
        this.CommonService = CommonService;
    }

    logout(evt) {
        evt.preventDefault();

        this.MobileAppService.logout();

        window.location = this.CommonService.getBaseUrl() + '/logout';
    }
}

export default LogoutController;
